import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7014a114"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "searchBox" }
const _hoisted_2 = { class: "optionsBox" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "搜索框", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "about" }, "搜索结果数量", -1))
const _hoisted_5 = { class: "operation" }
const _hoisted_6 = { class: "optionsBox" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "添加", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "about" }, "添加一个搜索引擎", -1))
const _hoisted_9 = { class: "btns" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_11 = { class: "optionsBox" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "添加", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "about" }, "添加一个搜索引擎", -1))
const _hoisted_14 = { class: "operation" }
const _hoisted_15 = { class: "tools" }
const _hoisted_16 = ["onClick"]

import { ref, reactive } from "vue";
import data from "@/data/data";
import notify from "@/utils/notify/notify";
import local from "@/utils/localData/local";
import { Check, Close } from "@element-plus/icons-vue";

/**
 * 保存配置并提示
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'search',
  setup(__props) {

function saveAndNotify(msg: Array<string>, type: boolean) {
    notify(type ? msg[0] : msg[1], type ? 1 : 3);
    local.save();
}
/**
 * 搜索引擎删除
 */
function deleteSo(i: number) {
    // 是否允许删除
    if (data.saveData.so.length == 1) {
        return data.notify("只有最后一个啦！", "warning");
    }
    if (i == data.saveData.soIndex) {
        return data.notify("不能删除当前正在使用的搜索引擎哦！", "warning");
    }
    // 删除索引判断
    if (data.saveData.soIndex > i) {
        data.saveData.soIndex -= 1;
    }
    // 删除
    data.saveData.so.splice(i, 1);
    notify("删除成功", 1);
    local.save();
}

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_input_number, {
          modelValue: _unref(data).saveData.soBoxlistShowNum,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).saveData.soBoxlistShowNum) = $event)),
          min: 1,
          max: 10,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (
                        saveAndNotify(
                            [
                                `设置成功，当前展示${_unref(data).saveData.soBoxlistShowNum}个`
                            ],
                            true
                        )
                    ))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(data).soSelectAdd = true))
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).saveData.so, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["soItem", {
                            soItemAction: _unref(data).saveData.soIndex == index
                        }]),
              onClick: ($event: any) => (_unref(data).saveData.soIndex = index)
            }, [
              _createElementVNode("div", null, [
                _createVNode(_component_el_icon, {
                  class: _normalizeClass(["el-icon-check", {
                                    'el-icon-check-action':
                                        _unref(data).saveData.soIndex == index
                                }])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Check))
                  ]),
                  _: 2
                }, 1032, ["class"]),
                _createElementVNode("p", null, _toDisplayString(item.name), 1)
              ]),
              _createVNode(_component_el_icon, {
                class: "el-icon-close",
                onClick: ($event: any) => (deleteSo(index))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Close))
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 10, _hoisted_16))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})